const QUERIES = {
  CATEGORYS_LIST: 'categorys-list',
  POSTS_LIST: 'posts-list',
  USERS_LIST: 'users-list',
  MEDIA_LIST: 'media-list',
  MEDIAS_LIST: 'media-list',
}

export {QUERIES}
